import { AxiosResponse } from 'axios';
import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { api } from 'api';
import * as actionType from './actionTypes';
import * as action from './actions';

export interface IFilePayload {
	payload: number; // request url | id
	type: string;
}

function* fetchOfferPDF({ payload }: IFilePayload) {
	try {
		const response: AxiosResponse<any> = yield api.utils.apiUtilsPrintIdGet(
			payload,
			{ responseType: 'blob' }
		);
		yield put(action.fileSuccess(response.data));
	} catch (error: any) {
		yield put(action.fileError(error));
	}
}

export function* watchFetchOfferPDF() {
	yield takeEvery(actionType.FETCH_OFFER_PDF, fetchOfferPDF);
}

function* fileSaga() {
	yield all([fork(watchFetchOfferPDF)]);
}

export default fileSaga;
